
export default function About() {
  return (
    <section id="quienes-somos" className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div>
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6">
              Una red que impulsa la innovación desde el territorio
            </h2>
            
            <div className="space-y-6 text-lg text-gray-700 leading-relaxed">
              <p>
                <strong className="text-teal-600">Territorio360</strong> es una asociación sin ánimo de lucro que nace con un propósito claro: <strong>fomentar la innovación en el entorno rural y territorial</strong>, generando oportunidades sostenibles para quienes habitan y trabajan en él.
              </p>
              
              <p>
                Somos un punto de encuentro entre administraciones, empresas, universidades y comunidades locales. Creemos que la verdadera transformación se construye colaborando, compartiendo conocimiento y creando redes de apoyo.
              </p>
              
              <p>
                En cada proyecto ponemos el foco en tres valores: <strong className="text-teal-600">innovación, sostenibilidad y cooperación.</strong>
              </p>
              
              <blockquote className="border-l-4 border-teal-600 pl-6 italic text-xl text-gray-800 bg-white p-6 rounded-r-lg shadow-sm">
                Porque cuando las personas se unen, la innovación florece incluso en los lugares más pequeños.
              </blockquote>
            </div>
          </div>
          
          <div className="relative">
            <img 
              src="https://readdy.ai/api/search-image?query=Group%20of%20diverse%20professionals%20collaborating%20in%20a%20modern%20rural%20innovation%20center%2C%20people%20working%20together%20on%20laptops%20and%20tablets%2C%20bright%20natural%20lighting%2C%20sustainable%20architecture%20with%20wooden%20elements%2C%20green%20plants%2C%20representing%20cooperation%20and%20innovation%20in%20rural%20territories%2C%20professional%20photography%2C%20warm%20and%20welcoming%20atmosphere&width=600&height=800&seq=about-territorio360&orientation=portrait"
              alt="Equipo colaborando en innovación rural"
              className="w-full h-96 object-cover rounded-lg shadow-lg"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-teal-600/20 to-transparent rounded-lg"></div>
          </div>
        </div>
      </div>
    </section>
  );
}
